import { render, staticRenderFns } from "./keywordsearch.vue?vue&type=template&id=a94f341e&scoped=true"
import script from "./keywordsearch.vue?vue&type=script&lang=js"
export * from "./keywordsearch.vue?vue&type=script&lang=js"
import style0 from "./keywordsearch.vue?vue&type=style&index=0&id=a94f341e&prod&scoped=true&lang=scss"
import style1 from "./keywordsearch.vue?vue&type=style&index=1&id=a94f341e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94f341e",
  null
  
)

export default component.exports